import * as _ from 'lodash';
import { RECEIVE_USER_PROFILES, REQUEST_USER_PROFILES } from '@Actions/userProfilesActions';
const defaultState = {
    loading: false,
    invitedProfiles: [],
    activeProfiles: [],
    inactiveProfiles: []
};
export const userProfilesReducer = function (state = defaultState, action) {
    switch (action.type) {
        case REQUEST_USER_PROFILES:
            return _.assign({}, state, {
                loading: true
            });
        case RECEIVE_USER_PROFILES:
            return _.assign({}, state, {
                loading: false,
                invitedProfiles: [...action.invitedProfiles],
                activeProfiles: [...action.activeProfiles],
                inactiveProfiles: [...state.inactiveProfiles]
            });
        default:
            return state;
    }
};
